import { Component } from '@angular/core';
import { ORCIDInvitedPositionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Invited Positions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidinvitedposition-form',
    templateUrl: './orcidinvitedposition.form.component.html'
})
export class ORCIDInvitedPositionFormComponent extends BaseFormComponent {
    public record!: ORCIDInvitedPositionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

